module.exports = __webpack_public_path__ + "img/banner-covid.54cc3be4.png";